import React, { useEffect, useState } from "react";
import { View, Text, TouchableOpacity, StyleSheet, Modal } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { UIManager, findNodeHandle, DimensionValue } from "react-native";
import { useChat } from "../../context/ChatContext";

const DeleteConfirmationModal = ({
  isVisible,
  onClose,
  onDeleteForEveryone,
  selectedMessages,
  onDeleteForMe,
  chatContainerRef,
}) => {
  const { chatData, userDataRef } = useChat();
  const [modalPosition, setModalPosition] = useState<{
    width: DimensionValue;
    left: number;
    bottom: number;
  }>({
    width: "95%",
    left: 10,
    bottom: 15,
  });

  const canDeleteForEveryone = selectedMessages.every((messageId) => {
    const message = chatData.find((msg) => msg.messageId === messageId);
    return message && message.userId === userDataRef.current.username;
  });

  useEffect(() => {
    if (chatContainerRef?.current) {
      UIManager.measureInWindow(
        findNodeHandle(chatContainerRef.current),
        (x, y, width, height) => {
          setModalPosition({
            width: width + 40,
            left: x - 20,
            bottom: 15,
          });
        }
      );
    }
  }, [chatContainerRef]);

  return (
    <Modal
      visible={isVisible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableOpacity
        style={styles.overlay}
        activeOpacity={1}
        onPress={onClose}
      >
        <View
          style={{
            position: "absolute",
            backgroundColor: AppColors.grayColor_D9D9D9,
            padding: 10,
            alignItems: "center",
            width: modalPosition.width,
            left: modalPosition.left,
            bottom: modalPosition.bottom,
          }}
        >
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_16,
              { marginBottom: 20, color: AppColors.black_121212 },
            ]}
          >
            Delete Message?
          </Text>
          {canDeleteForEveryone && (
            <TouchableOpacity
              onPress={onDeleteForEveryone}
              style={{
                backgroundColor: AppColors.white,
                width: 330,
                justifyContent: "center",
                padding: 20,
                marginBottom: 10,
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_12,
                  { color: AppColors.red_FA0A0A },
                ]}
              >
                Delete for everyone
              </Text>
            </TouchableOpacity>
          )}
          <TouchableOpacity
            onPress={onDeleteForMe}
            style={{
              backgroundColor: AppColors.white,
              width: 330,
              justifyContent: "center",
              padding: 20,
              marginBottom: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_12,
                { color: AppColors.red_FA0A0A },
              ]}
            >
              Delete for me
            </Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
});

export default DeleteConfirmationModal;
